import React from 'react';
import { Button } from '@/components/ui/button';

const EmptyStateBlock = ({ icon: Icon, title, description, actionLabel, onAction, secondaryText }) => (
  <div className="rounded-lg border border-[rgba(15,23,42,0.1)] bg-surface-grouped px-5 py-8 shadow-primeSm md:px-8 md:py-10">
    <div className="mx-auto flex max-w-[520px] flex-col items-center gap-4 text-center">
      {Icon && (
        <div
          className="flex h-[52px] w-[52px] items-center justify-center rounded-xl bg-[#E8F2FF] text-[#0A84FF] shadow-primeSm"
          aria-hidden
        >
          <Icon className="h-6 w-6" />
        </div>
      )}
      <div className="flex flex-col gap-1">
        <h2 className="text-lg font-extrabold text-label-primary md:text-xl">{title}</h2>
        <p className="text-sm leading-relaxed text-label-secondary">{description}</p>
      </div>
      {actionLabel && onAction && (
        <Button className="min-w-[160px] bg-brand-500 hover:bg-brand-600" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
      {secondaryText && <p className="text-xs text-label-tertiary">{secondaryText}</p>}
    </div>
  </div>
);

export default EmptyStateBlock;
